import { Checkbox, Div, Flex, Gutter, Title } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';

import styles from './EndOfLease.module.scss';

interface EndOfLeaseProps {
  eolExtension: boolean;
  eolBuyout: boolean;
  setEolExtension: (eolExtension: boolean) => void;
  setEolBuyout: (eolBuyout: boolean) => void;
  showExtensionOption?: boolean;
}

const EndOfLease = ({ eolExtension, eolBuyout, setEolExtension, setEolBuyout, showExtensionOption = true }: EndOfLeaseProps) => {
  const { t } = useTranslation('organizationForm');

  return (
    <Div padding={{ size: 'lg' }} boxShadow="md">
      <Title size={'sm'}>{t('end_of_lease.end_of_lease')}</Title>
      <Flex directionColumn className={styles['customer-organization-form__end-of-lease-inputs-container']}>
        <Gutter size="layout-5" />
        <Checkbox label={t('end_of_lease.eol_return')} checked={true} disabled={true} />
        {showExtensionOption && (
          <>
            <Gutter size="layout-5" />
            <Checkbox label={t('end_of_lease.eol_extension')} checked={eolExtension} onChange={() => setEolExtension(!eolExtension)} />
          </>
        )}
        <Gutter size="layout-5" />
        {/* TODO - Add checkbox for upgrading the device once backend API supports this */}
        <Checkbox label={t('end_of_lease.eol_buyout')} checked={eolBuyout} onChange={() => setEolBuyout(!eolBuyout)} />
        <Gutter size="layout-5" />
      </Flex>
    </Div>
  );
};

export default EndOfLease;
